import { CSSProperties, FC } from "react";
import { Accordion } from "@/components/Accordion";
import { Blocks, BuilderBlock } from "@builder.io/sdk-react";
import { BuilderProps } from "@/types/builder/BuilderProps";
import { objectToCssProperties } from "@/helpers/objectToCssProperties";

type AccordionBlockProps = {
  columnsCount?: number;
  multipleOpen?: boolean;
  preopenedSectionIndex?: number;
  items?: {
    label?: React.ReactNode;
    labelBlock: BuilderBlock[];
    dlt: string;
    dld: string;
    blocks: BuilderBlock[];
  }[];
  tabStyle: CSSProperties;
  tabHoverStyle: CSSProperties;
  tabActiveStyle: CSSProperties;
  tabFocusStyle: CSSProperties;
  children?: React.ReactNode;
} & BuilderProps;

export const AccordionBlock: FC<AccordionBlockProps> = ({
  columnsCount = 2,
  multipleOpen = false,
  preopenedSectionIndex = 0,
  items = [],
  tabStyle,
  tabHoverStyle,
  tabActiveStyle,
  tabFocusStyle,
  builderBlock,
  builderComponents,
  builderContext,
  builderLinkComponent,
}) => {
  if (!items?.length) {
    return null;
  }

  return (
    <>
      <style>
        {`
.${builderBlock.id} summary {
  ${objectToCssProperties(tabStyle ?? {})}
}

.${builderBlock.id} summary:hover {
  ${objectToCssProperties(tabHoverStyle ?? {})}
}

.${builderBlock.id} summary:focus {
  ${objectToCssProperties(tabFocusStyle ?? {})}
}

.${builderBlock.id} summary:active {
  ${objectToCssProperties(tabActiveStyle ?? {})}
}

.${builderBlock.id} summary svg {
  ${objectToCssProperties(tabStyle ?? {})}
}

.${builderBlock.id} summary.group:hover svg {
  ${objectToCssProperties(tabHoverStyle ?? {})}
}

.${builderBlock.id} summary.group:focus svg {
  ${objectToCssProperties(tabFocusStyle ?? {})}
}

.${builderBlock.id} summary.group:active svg {
  ${objectToCssProperties(tabActiveStyle ?? {})}
}
        `}
      </style>
      <Accordion
        columnsCount={columnsCount}
        multipleOpen={multipleOpen}
        preopenedSectionIndex={preopenedSectionIndex}
        items={items?.map((item, index) => ({
          label: [
            <Blocks
              key={builderBlock?.id}
              parent={builderBlock?.id}
              registeredComponents={builderComponents}
              context={builderContext}
              path={`items.${index}.label`}
              blocks={item.labelBlock}
              linkComponent={builderLinkComponent}
            />,
          ],
          dlt: item.dlt,
          dld: item.dld,
          children: [
            <Blocks
              key={builderBlock?.id}
              parent={builderBlock?.id}
              registeredComponents={builderComponents}
              context={builderContext}
              path={`items.${index}.blocks`}
              blocks={item.blocks}
              linkComponent={builderLinkComponent}
            />,
          ],
        }))}
      />
    </>
  );
};
